import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import Typed from "typed.js";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import RouteApi from "../Backend/Backend";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify"; // Import Toastify for notifications
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Make_CBT = () => {

  const schoolname = localStorage.getItem("schoolname");

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }], // Added line for sub/super
      ["blockquote", "code-block"],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const formats = [
    "header", "bold", "italic", "underline", "strike",
    "align", "list", "bullet",
    "color", "background",
    "script", // Added "script" format
    "blockquote", "code-block",
    "link", "image", "video"
  ];

  const { id } = useParams(); // Retrieve the dynamic id from the route params
  const navigate = useNavigate();

  const axiosInstance = axios.create({
      baseURL: `/${id}/v3`, // Adjust base URL dynamically
      headers: {
          "Content-Type": "application/json",
      },
  });

  const location = useLocation();
  console.log("State received:", location.state);

  const { trigger, required, message, cbtId } = location.state || {};

  useEffect(() => {
    if (!cbtId) {
      navigate("../"+id+"/cbt");
    }
  }, [cbtId, navigate]);

  console.log("Trigger:", trigger);
  console.log("Message:", message);
  console.log("CBT ID:", cbtId);

  const { getCbtByTokenId, handleCbtColumn, handleUpdateCbtColumn, handleGetAllCbtColumns, handleGetCbtColumnById, saveStepperProgress } = RouteApi();

  const [formData, setFormData] = useState({
    type: "",
    question: "",
    options: ["", "", "", ""],
    correctAnswer: "",
    theoryAnswer: "",
    instructionText: "",
  });

  const handleChange = async (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    await saveFieldToDb(updated);
  };

  const handleOptionChange = async (index, value) => {
    const updatedOptions = [...formData.options];
    updatedOptions[index] = value;

    const updated = { ...formData, options: updatedOptions };
    setFormData(updated);
    await saveFieldToDb(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // You might want to validate first
    if (!formData.type) {
      toast.error("❌ Please select a question type.");
      return;
    }

    const tokenId = cbtId;
    if (!tokenId || !activeColumnId) {
      toast.error("❌ Missing CBT ID or Column ID.");
      return;
    }

    const payload = {
      tokenid: tokenId,
      row_id: activeColumnId,
      ques_type: formData.type,
      ques:
        formData.type === "instruction"
          ? formData.instructionText
          : formData.question,
      ans1: formData.options[0] || "",
      ans2: formData.options[1] || "",
      ans3: formData.options[2] || "",
      ans4: formData.options[3] || "",
      anscor: formData.correctAnswer || "",
      solution: formData.theoryAnswer || "",
    };

    try {
      const response = await handleUpdateCbtColumn(payload);

      if (response.success) {
        toast.success("✅ Question saved successfully!");
        handleFetchColumns();
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      console.error("Submit Error:", error);
      toast.error("❌ Failed to save question");
    }
  };

  const saveFieldToDb = async (updatedForm) => {
    const tokenId = cbtId;
    if (!tokenId || !activeColumnId) return;

    const payload = {
      tokenid: tokenId,
      row_id: activeColumnId,
      ques_type: updatedForm.type,
      ques: updatedForm.type === "instruction" ? updatedForm.instructionText : updatedForm.question,
      ans1: updatedForm.options?.[0] || "",
      ans2: updatedForm.options?.[1] || "",
      ans3: updatedForm.options?.[2] || "",
      ans4: updatedForm.options?.[3] || "",
      anscor: updatedForm.correctAnswer || "",
      solution: updatedForm.theoryAnswer || "",
    };

    const response = await handleUpdateCbtColumn(payload);

    if (response.success) {
      handleFetchColumns(); // 🔁 Refresh columns
    } else {
      console.warn("Autosave failed:", response.message);
    }
  };

  const [cbtTask, setCbtTask] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCbtTaskByToken = async (cbtId) => {
    setLoading(true);
    setError(null);

    const result = await getCbtByTokenId(cbtId);
    console.log("CBT Task By Token:", result);
    
    if (result.success && result.task) {
      setCbtTask(result.task);
      console.log("CBT Title:", result.task.title); // Accessing the title
    } else {
      setCbtTask(null);
      setError("CBT task not found or failed to load.");
    }

    setLoading(false);
  };

  const [column, setColumn] = useState([]);
  const [activeColumnId, setActiveColumnId] = useState(null); // track selected column

  useEffect(() => {
    loadCbtTaskByToken(cbtId); // initial load
  }, [cbtId]);

  const clickSoundRef = useRef(null);

  useEffect(() => {
    clickSoundRef.current = new Audio("/assets/sound/3.mp3"); // place the sound file in /public/assets/sound
  }, []);

  const playSound = () => {
    if (clickSoundRef.current) {
      clickSoundRef.current.currentTime = 0; // rewind to start
      clickSoundRef.current.play().catch((e) => {
        console.warn("Sound play failed:", e);
      });
    }
  };

  const handleClick = async () => {
    playSound();

    const tokenId = cbtId; // replace with your actual token id

    if (!tokenId) {
      toast.error("Missing CBT token ID");
      return;
    }

    const result = await handleCbtColumn(tokenId);

    if (result.success) {
      //toast.success("✅ CBT column created successfully!");
      // Additional logic like refreshing state, etc.

      handleFetchColumns();

      const lastId = localStorage.getItem("lastSelectedCbtColumnId");
      handleFetchColumnById(parseInt(lastId) + 1);

    } else {
      toast.error(`❌ Error Encounter! Err Message - ${result.error}`);
    }
  };

  const handleUpdateColumn = async (updateData) => {
    
      const { tokenid, id } = updateData;

      if (!tokenid || !id) {
          toast.error("❌ Missing ID or Token ID");
          return;
      }

      const result = await handleUpdateCbtColumn(updateData);

      if (result.success) {
          toast.success("✅ CBT column updated successfully!");
      } else {
          toast.error(`❌ Error Encounter! Err Message - ${result.error}`);
      }
  };

  const handleFetchColumns = async () => {
    const tokenId = cbtId;

    if (!tokenId) {
      toast.error("❌ Missing CBT token ID");
      return;
    }

    const result = await handleGetAllCbtColumns(tokenId);

    if (result.success) {
     // toast.success("✅ Fetched all CBT columns!");
      setColumn(result.rows || []);
    } else {
      toast.error(`❌ Error Encounter! Err Message - ${result.error}`);
    }
  };

  const handleFetchColumnById = async (id) => {
    const tokenId = cbtId;

    if (!tokenId || !id) {
      toast.error("❌ Missing ID or Token ID");
      return;
    }

    const result = await handleGetCbtColumnById(id, tokenId);

    if (result.success) {
      //toast.success("✅ Fetched CBT column by ID!");
      setActiveColumnId(id);
      localStorage.setItem("lastSelectedCbtColumnId", id);
      await saveStepperProgress(id);

      const row = result.row;

      // Set formData from row data
      setFormData({
        type:
          row.ques_type || "",

        instructionText:
          row.ques_type === "instruction" ? row.ques || "" : "",

        question:
          row.ques_type !== "instruction" ? row.ques || "" : "",

        options: row.ques_type === "objective"
          ? [row.ans1, row.ans2, row.ans3, row.ans4].map((opt) => opt || "")
          : ["", "", "", ""],

        correctAnswer: row.anscor || "",

        theoryAnswer:
          row.ques_type === "theory" ? row.solution || "" : "",
      });
    } else {
      //toast.error(`❌ Error Encounter! Err Message - ${result.error}`);
    }
  };

  useEffect(() => {
    handleFetchColumns(); // fetch all columns

    const lastId = localStorage.getItem("lastSelectedCbtColumnId");
    if (lastId) {
      handleFetchColumnById(parseInt(lastId)); // 🔁 Restore previous selection
    }else{
      handleFetchColumnById(1); // 🔁 Restore previous selection
    }
  }, []);

  const [searchQuery, setSearchQuery] = useState("");

  // Filtered column list
  const filteredColumns = column.filter(col =>
    (col.ques_type + " " + col.ques + " " + col.ques_id)
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const handleDeleteColumn = async (columnId) => {
    const token = localStorage.getItem("jwtToken");

    try {
      const response = await axiosInstance.post(
        "/cbt/delete/column",
        {
          column_id: columnId,
          tokenid: cbtId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success("✅ Column deleted!");
        handleFetchColumns(); // Refresh the list
        const lastId = localStorage.getItem("lastSelectedCbtColumnId");
        handleFetchColumnById(parseInt(lastId) - 1);
      } else {
        toast.error(`❌ Delete failed: ${response.data.message}`);
      }
    } catch (error) {
      toast.error("❌ Server error while deleting");
      console.error("Delete Error:", error);
    }
  };

  const swiperRef = useRef(null);

  useEffect(() => {
    if (!swiperRef.current || !filteredColumns.length || !activeColumnId) return;

    const activeIndex = filteredColumns.findIndex(col => col.row_id === activeColumnId);


    if (activeIndex !== -1) {
      swiperRef.current.slideTo(activeIndex);
    }
  }, [activeColumnId, filteredColumns]);

  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);


  return (
    <div className="bg-back">

      <div className="fixed-top">
        <div className="bg-white" style={{ left: "300px" }}>
          <div className="row d-flex px-4">
            <div className="d-none d-lg-flex col-lg-3">
            <div className="py-4">
              <div className="fs-t text-purple2 fw-medium">
                {schoolname}
              </div>
             </div>
            </div>

            <div className="col-lg-6 col-9 ms-lg-n6">
              <div className="py-4">
              <div className="fs-t text-dark fw-medium">
                CBT Workspace
              </div>
             </div>
            </div>

            <div className="col-lg-3 col-3 text-end ms-lg-4">
              <Link to={"/"+id+"/cbt"}>
                <div className="pt-4">
                <i class="bi bi-arrow-90deg-left fs-t text-dark fw-medium"></i>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </div>
     
      {loading ? (
        <>
        {!isMobile ?
          <div
            className="sidebar-loader bg-white p-4"
            style={{
              width: "300px",
              height: "100vh",
              overflowY: "auto",
              borderRight: "1px solid #eee",
            }}
          >
            <div className="mt-16">
            {[...Array(5)].map((_, i) => (
              <Skeleton
                key={i}
                height={35}
                className="mb-3 py-5"
                style={{ borderRadius: "10px" }}
              />
            ))}
          </div>
          </div>
          :
          <></>
          }
          <Skeleton height={40} className="mb-3" />
        </>
      ) : (
      <>
      {isMobile ?
      <></>
      :
      <div
        class="docs-nav-sidebar border-none bg-white shadow-none"
        style={{ width: "300px", border: "none", height: "700px" }}
      >
        <div class="py-5">
          
        </div>
        
        <div class="nav-top border-0 py-0 mt-6">
          <nav class="navigation navbar navbar-expand-lg px-4">
              <div class="collapse navbar-collapse mb-0" id="navbarNav">
                <div className="col-lg-12 mb-3">
                <input
                  type="text"
                  className="form-control form-control-md rounded-4 bg-light text-dark"
                  placeholder="Filter Search Columns"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </nav>
        </div>
        <div class=" docs-nav" data-simplebar>
          <nav class="navigation navbar navbar-expand-lg">
            <div class="collapse navbar-collapse mb-0" id="navbarNav">
              <ul
                class="navbar-nav flex-column text-start px-4 shadow-none mb-15"
                id="sidebarnav"
              >
                {column.length > 0 ? (
                  <>
                    <li className="mt-2 mb-3 bg-transparent">
                      <div className="text-start text-dark fs-3">Question List</div>
                    </li>

                    {[...filteredColumns].reverse().map((col, index) => {
                      const stripHtml = (html) => {
                        const doc = new DOMParser().parseFromString(html, 'text/html');
                        return doc.body.textContent || "";
                      };

                      const shortQues = col.ques
                        ? stripHtml(col.ques).split(" ").slice(0, 12).join(" ") + "..."
                        : "No question set yet...";

                      const isActive = activeColumnId === col.row_id;

                      const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

                      return (
                        <li
                          key={col.row_id}
                          className={`card ${isActive ? "bg-purple4" : "bg-back"} shadow-none cursor-pointer mb-4`}
                          onClick={() => handleFetchColumnById(col.row_id)}
                        >
                          <div className={`row px-3 py-2 ${isActive ? "text-white" : "text-dark"}`}>
                            <div className="col-8">
                            <i className={`bi bi-bullseye fs-4 ${isActive ? "text-white" : "text-purple4"}`}></i>
                            <span className="col fs-4 ms-2">
                              {col.ques_type === "instruction" || col.ques_type === "theory"
                                ? `${capitalize(col.ques_type)}`
                                : col.ques_type === "objective"
                                ? `${capitalize(col.ques_type)} ${col.row_id -1}`
                                : `New Column`}
                            </span>
                            </div>

                            <div className="col-4 text-end">
                              <button
                                className={`btn ${isActive ? "btn-white" : "btn-white tetx-dark"}  btn-sm rounded-pill`}
                                onDoubleClick={() => handleDeleteColumn(col.row_id)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </div>

                            <div className="px-4 mt-2">
                              <span className={`fs-5 ${isActive ? "text-white" : "text-dark"}`}>
                                {shortQues}
                              </span>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <li className="col-12 text-center py-20 px-4">
                      <div className="text-gray-700 fs-5 mt-3">
                        <i className="bi bi-stars text-warning fs-3"></i> Smart Ai -{" "}
                        <span className="text-dark fw-medium">
                          Hey there! You know you can use Smart Ai to generate questions for you! Isn't that Fun!
                        </span>
                      </div>
                      <div className="mt-6">
                        <button className="btn btn-purple rounded-pill text-white">
                          <i className="bi bi-stars text-warning fs-3"></i> Ask Smart Ai
                        </button>
                      </div>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </nav>
        </div>
      </div>
      }

      <div
        className="docs-wrapper bg-back py-lg-10 py-5"
        style={isMobile ? {} : { left: "50px", width: "calc(100% - 300px)" }}
      >
        <div className="position-relative overflow-hidden px-0 px-lg-4 bg-dark mt-lg-n5 mt-5 pb-5 pb-lg-5">
         
          <div className="container py-lg-4">
            <div className="pt-6">
              <div className="row px-lg-5 px-md-4 px-4 row">
                <div className="col-lg-8 mb-4 mb-lg-0">
                  <div className="text-white fs-t fw-medium">
                    <i class="bi bi-folder2-open"></i>{" "}
                    {loading ? (
                      <Skeleton width={200} height={24} baseColor="#dddddd" highlightColor="#f3f3f3" />
                    ) : (
                      <></>
                    )}
                    {cbtTask?.title}
                  </div>
                  <div className="fs-4 text-white">
                    Creating for - {cbtTask?.cbt_class}
                  </div>
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0 text-lg-end">
                  <button className="btn btn-white rounded-pill cursor-pointer"
                  data-bs-toggle="modal"
                  data-bs-target="#editcbt_task">
                    Edit CBT Task
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container py-5 px-lg-14 px-2">
          <div className="col-12 mt-n9">
            <div
              className="card shadow-none bg-white"
              style={{ borderRadius: "30px" }}
            >
              <div className="px-lg-8 py-lg-4 px-6 py-4">
                {column.length > 0 ? (
                  <div className="">
                    <div className="d-flex align-items-center">
                    <div className="col">
                    <div className="fs-3 text-dark mb-2">
                      <i className="bi bi-disc"></i> Make CBT
                    </div>
                    <span className="fs-5 text-dark">
                      Fill the details below to set up parameters
                    </span>
                    </div>

                    </div>
                    <form onSubmit={handleSubmit} className="row mt-4">
                      <div className="col-lg-7 mb-6">
                        <select
                          className="form-select form-select-lg rounded-4 bg-back text-dark"
                          name="type"
                          value={formData.type}
                          onChange={handleChange}
                        >
                          <option value="">Select Question Type</option>
                          <option value="instruction">Instruction</option>
                          <option value="objective">Objective</option>
                          <option value="theory">Theory</option>
                        </select>
                      </div>

                      {formData.type === "instruction" && (
                        <div className="col-lg-12 mb-3">
                          <textarea
                            className="form-control form-control-lg rounded-4 bg-back text-dark"
                            name="instructionText"
                            placeholder="Set up Instruction"
                            rows="3"
                            value={formData.instructionText}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      )}

                      {(formData.type === "objective" ||
                        formData.type === "theory") && (
                        <>
                          <div className="col-lg-12 mb-3">
                           
                            <ReactQuill
                              theme="snow"
                              value={formData.question}
                              onChange={(value) =>
                                setFormData((prev) => ({ ...prev, question: value }))
                              }
                              modules={modules}
                              formats={formats}
                              placeholder="Set up Question"
                              className="form-control form-control-lg rounded-4 bg-back text-dark quill-no-border"
                            />
                          </div>
                        </>
                      )}

                      {formData.type === "objective" && (
                        <>
                          <div className="col-lg-12 mb-3">
                            <div className="row">
                              {formData.options.map((opt, idx) => (
                                <div className="col-lg-6 mb-3">
                                  <input
                                    key={idx}
                                    type="text"
                                    className="form-control form-control-lg rounded-4 bg-back text-dark"
                                    placeholder={`Option ${String.fromCharCode(
                                      65 + idx
                                    )}`}
                                    value={opt}
                                    onChange={(e) =>
                                      handleOptionChange(idx, e.target.value)
                                    }
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="col-lg-9 mb-3">
                            <select
                              className="form-select form-select-lg rounded-4 bg-back text-dark"
                              name="correctAnswer"
                              value={formData.correctAnswer}
                              onChange={handleChange}
                            >
                              <option value="">Select correct option</option>
                              {formData.options.map((opt, idx) => (
                                <option key={idx} value={opt}>
                                  {String.fromCharCode(65 + idx)}. {opt}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}

                      {formData.type === "theory" && (
                        <div className="mb-3">
                          <ReactQuill
                              theme="snow"
                              placeholder="Set up Correct Answer"
                              value={formData.theoryAnswer}
                              onChange={(value) =>
                                setFormData((prev) => ({ ...prev, theoryAnswer: value }))
                              }
                              modules={modules}
                              formats={formats}
                              className="form-control form-control-lg rounded-4 bg-back text-dark quill-no-border"
                            />
                        </div>
                      )}

                      <div className="col-lg-6">
                        <button
                          type="submit"
                          className="btn btn-lg btn-dark mt-3 rounded-pill px-4 py-2"
                        >
                          Save {formData.type}
                        </button>
                      </div>
                    </form>
                  </div>
                ) : (
                  <>
                    <div className="py-lg-5 text-center">
                      
                      <img
                        src="../assets/images/background/ready.svg"
                        alt="CBT Illustration"
                        style={{ width: "30%" }}
                        className="mb-4"
                      />
                      <div className="">
                        <span className="fs-t fw-medium text-purple3 mt-4">
                          Ready To Upload!
                        </span>
                      </div>
                      <div className=""></div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {column.length && isMobile > 0 ? (
            <>
              <div className="px-4 mt-6 mb-3 bg-transparent">
                <div className="text-start text-dark fs-t">Question List</div>
              </div>

              <div className="px-4">
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                grabCursor={true}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                breakpoints={{
                  640: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
                style={{ paddingBottom: "40px" }}
              >
                {[...filteredColumns].map((col, index) => {
                  const stripHtml = (html) => {
                    const doc = new DOMParser().parseFromString(html, "text/html");
                    return doc.body.textContent || "";
                  };

                  const shortQues = col.ques
                    ? stripHtml(col.ques).split(" ").slice(0, 12).join(" ") + "..."
                    : "No question set yet...";

                  const isActive = activeColumnId === col.row_id;

                  return (
                    <SwiperSlide key={col.row_id}>
                      <div
                        className={`card ${isActive ? "bg-purple4" : "bg-back"} shadow-none cursor-pointer mb-4`}
                        onClick={() => handleFetchColumnById(col.row_id)}
                        style={{
                          borderRadius: "20px",
                          color: "white",
                        }}
                      >
                        <div className={`row px-3 py-2 ${isActive ? "text-white" : "text-dark"}`}>
                          <div className="col-8 d-flex align-items-center">
                            <i className={`bi bi-bullseye fs-4 ${isActive ? "text-white" : "text-purple4"}`}></i>
                            <span className="col fs-4 ms-2">
                              {col.ques_type === "instruction" || col.ques_type === "theory"
                                ? `${capitalize(col.ques_type)}`
                                : col.ques_type === "objective"
                                ? `${capitalize(col.ques_type)} ${col.row_id - 1}`
                                : `New Column`}
                            </span>
                          </div>

                          <div className="col-4 text-end">
                            <button
                              className={`btn ${isActive ? "btn-white" : "btn-white tetx-dark"} btn-sm rounded-pill`}
                              onDoubleClick={(e) => {
                                handleDeleteColumn(col.row_id);
                              }}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>

                          <div className="px-4 mt-2">
                            <span className={`fs-5 ${isActive ? "text-white" : "text-dark"}`}>
                              {shortQues}
                            </span>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              </div>

              <div className="col-12 px-4 mb-8 text-center mt-n6">
                <div className="row d-flex">
                  <button className="btn btn-transparent col-2" onClick={() => swiperRef.current?.slidePrev()}>
                    <i className="bi bi-arrow-left text-dark fs-t"></i>
                  </button>
                  <div className="col-8 mt-3">
                    <span className="fs-4 text-dark"> Swipe </span>
                  </div>
                  <button className="btn btn-transparent col-2" onClick={() => swiperRef.current?.slideNext()}>
                    <i className="bi bi-arrow-right text-dark fs-t"></i>
                  </button>
                </div>
              </div>

              <>
                <li className="col-12 text-center py-4 px-4">
                  <div className="text-gray-700 fs-5 mt-3">
                    <i className="bi bi-stars text-warning fs-3"></i> Smart Ai -{" "}
                    <span className="text-dark fw-medium">
                      Hey there! You know you can use Smart Ai to help with questions!
                    </span>
                  </div>
                  <div className="mt-6">
                    <button className="btn btn-purple rounded-pill text-white" data-bs-toggle="offcanvas"
                      data-bs-target="#smart-ai"
                      aria-controls="smart-ai">
                      <i className="bi bi-stars text-warning fs-3"></i> Ask Smart Ai
                    </button>
                  </div>
                </li>
              </>
            </>
            ) : (
              <>
                <li className="col-12 text-center py-4 px-4">
                  <div className="text-gray-700 fs-5 mt-3">
                    <i className="bi bi-stars text-warning fs-3"></i> Smart Ai -{" "}
                    <span className="text-dark fw-medium">
                      Hey there! You know you can use Smart Ai to help with questions!
                    </span>
                  </div>
                  <div className="mt-6">
                    <button className="btn btn-purple rounded-pill text-white" data-bs-toggle="offcanvas"
                      data-bs-target="#smart-ai"
                      aria-controls="smart-ai">
                      <i className="bi bi-stars text-warning fs-3"></i> Ask Smart Ai
                    </button>
                  </div>
                </li>
              </>
            )
          }

        </div>
      </div>

      <div
        class="btn btn-dark fs-4 text-white shadow-none end-0 me-4 me-lg-6 rounded-pill float mb-3"
        onClick={handleClick}
      >
        <i className="bi bi-plus"></i>
        <span>Add New</span>
      </div>

      <div
        className="modal fade"
        id="editcbt_task"
        tabindex="-1"
        role="dialog"
        data-bs-backdrop="static"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className={
            isMobile
              ? "modal-dialog modal-dialog-centered modal-fullscreen"
              : "modal-dialog modal-lg modal-dialog-centered"
          }
          role="document"
        >
          <div
            className={isMobile ? "modal-content" : "modal-content"}
            style={
              isMobile
                ? { border: "#fff" }
                : { borderRadius: "30px", border: "#fff" }
            }
          >
            <div className="modal-header border-0 mt-4">
              <div className="fs-t1 text-purple2">
                <i className="bi bi-plus"></i> Edit CBT Task
              </div>

              <button
                className="btn btn-purple4 btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="bi bi-x-lg fw-bold fs-3 text-white"></i>
              </button>
            </div>
            <div className="modal-body py-0 mt-2 mb-4">
              <div className="">

              </div>
            </div>
          </div>
        </div>
      </div>
      
      </>
      )}

      <Footer/>
    </div>
  );
};

export default Make_CBT;
